import { sanitizeUrl } from '@braintree/sanitize-url'

let pendingRedirectHandler: ((e: Event) => void) | null = null

export const redirectAfterResultScreen = (url: string): void => {
  if (pendingRedirectHandler) {
    document.removeEventListener('click', pendingRedirectHandler)
  }
  const handleClick = (e: Event) => {
    if ((e.target as Element)?.closest('.sdk-payments-status__button')) {
      document.removeEventListener('click', handleClick)
      pendingRedirectHandler = null
      redirectTo(url)
    }
  }
  pendingRedirectHandler = handleClick
  document.addEventListener('click', handleClick)
}

export const redirectTo = (url: string) => {
    // sanitizeUrl is used only as a safety gate: it returns 'about:blank' for unsafe
    // schemes (javascript:, data:, ...). We navigate to the original url, not the
    // sanitized one, because sanitizeUrl percent-decodes the query (e.g. %2B -> +),
    // which corrupts merchants' pre-encoded callback signatures (e.g. base64 signData).
    const urlSanitized = sanitizeUrl(url)

    if (urlSanitized === 'about:blank') {
        console.error('Invalid URL ' + url)
    } else {
        window.location.href = url
    }

}

export const buildCallbackUrl = (baseUrl: string, status: string, paymentId: string | null): string => {
    const [urlWithoutFragment, ...fragmentParts] = baseUrl.split('#')
    const fragment = fragmentParts.length ? `#${fragmentParts.join('#')}` : ''
    const separator = urlWithoutFragment.includes('?') ? '&' : '?'
    const paymentIdParam = paymentId ? `&payment_id=${paymentId}` : ''
    return `${urlWithoutFragment}${separator}status=${status}${paymentIdParam}${fragment}`
}
